// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item_list_box[data-v-6a553771]{flex:1;overflow:hidden}.form_item[data-v-6a553771]{display:flex;padding:10px 0 10px 20px;border:1px dashed #ccc;margin-bottom:10px}.form_item .helper[data-v-6a553771]{width:100px;display:flex;justify-content:center;align-items:center;flex-direction:column}", ""]);
// Exports
module.exports = exports;
